import { Route } from 'react-router';
import { AuditLogPage } from '../AuditLogPage';
import { getAuditLogPath } from '../path/path';
import { getAuditLogEventDetailsPath } from '../_AuditLogEventDetailsPage/path/path';
import { AuditLogEventDetailsPage } from '../_AuditLogEventDetailsPage/AuditLogEventDetailsPage';

export const AuditLogRoutes = [
  <Route key={getAuditLogPath()} path={getAuditLogPath()} element={<AuditLogPage />} />,
  <Route
    key={getAuditLogEventDetailsPath()}
    path={getAuditLogEventDetailsPath()}
    element={<AuditLogEventDetailsPage />}
  />,
];
